import { render } from "./TheTitle.vue?vue&type=template&id=1cc5b0de&scoped=true"
import script from "./TheTitle.vue?vue&type=script&lang=js"
export * from "./TheTitle.vue?vue&type=script&lang=js"

import "./TheTitle.vue?vue&type=style&index=0&id=1cc5b0de&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc5b0de"]])

export default __exports__